import React from "react";
import injectSheet, { useTheme } from "react-jss";
import Icon from "../../assets/icons/Icon";
import classNames from "classnames";
import { globalTheme } from "../../styles/globalTheme";

const Backbutton = ({
  classes,
  children,
  onClick,
  disabled,
  className,
}) => {

  const theme = useTheme();

  return (
    <div>
      <button
        disabled={disabled === true ? true : false}
        tabIndex="-1"
        className={classNames(classes.backButton, className)}
        name="cancel"
        onClick={disabled === true ? () => {} : onClick}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <Icon
            type="arrow"
            rotate=""
            width="24px"
            disabled={disabled === true ? true : false}
            disabledColor="#8f919d"
            fill={theme.actionButtonColor}
          />
          <div style={{ marginTop: "2px", marginLeft: "4px" }}>{children}</div>
        </div>
      </button>
    </div>
  );
};

const styles = (theme) => ({
  backButton: {
    backgroundColor: "transparent",
    border: 0,
    cursor: "pointer",
    fontSize: "16px",
    padding: ["9px", "16px", "8px", "0"],
    color: theme.actionButtonColor, // theme.blue, //"#335cda",
    "&:focus": {
      outline: globalTheme.outline,
    },
  },
  "@media (max-width: 1023px)": {
    backButton: {
      marginTop: (props) => (props.marginTop ? props.marginTop : "14px"),
      textAlign: (props) => (props.align ? props.align : "center"),
      "& > div": {
        justifyContent: "center",
      },
      cursor: "none",
      "&:hover": {
        background: "transparent",
      },
    },
  },
});
export default injectSheet(styles)(Backbutton);
